interface ReportLoadingPanelProps {
  isDarkMode: boolean;
  icon: string;
  title: string;
  subtitle: string;
  withCards?: boolean;
}

export default function ReportLoadingPanel({
  isDarkMode,
  icon,
  title,
  subtitle,
  withCards = true,
}: ReportLoadingPanelProps) {
  const cardBorder = isDarkMode ? "border-dark-border" : "border-gray-200";
  const cardBg = isDarkMode ? "bg-dark-surface" : "bg-white";
  const pulse = isDarkMode ? "bg-white/10" : "bg-black/10";

  return (
    <div className={`mt-4 flex flex-col gap-4 ${cardBorder} rounded-lg ${cardBg} border p-3 sm:p-4`}>
      {withCards && (
        <div className="grid gap-3 grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className={`h-24 rounded-xl animate-pulse ${pulse}`}
              style={{ animationDelay: `${i * 100}ms` }}
            />
          ))}
        </div>
      )}

      <div
        className={`relative w-full overflow-hidden rounded-lg ${isDarkMode ? "bg-white/5" : "bg-black/5"}`}
        style={{ height: 300 }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
          <div className="relative flex items-center justify-center w-20 h-20">
            <span className="absolute inline-flex w-full h-full rounded-full bg-primary-500/20 animate-ping" />
            <span className="absolute inline-flex w-12 h-12 rounded-full border-4 border-primary-500 border-t-transparent animate-spin" />
            <span className="relative inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary-500/15">
              <i className={`${icon} text-primary-500 text-2xl animate-bounce`} />
            </span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <span className={`text-sm font-semibold ${isDarkMode ? "text-white" : "text-gray-900"}`}>
              {title}
            </span>
            <span className={`text-xs ${isDarkMode ? "text-white" : "text-gray-900"} opacity-70`}>
              {subtitle}
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className={`h-4 w-full rounded animate-pulse ${pulse}`}
            style={{ animationDelay: `${i * 120}ms` }}
          />
        ))}
      </div>
    </div>
  );
}
